module.exports = __webpack_public_path__ + "static/media/passport-example.a849b65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/passport-example.png
// module id = 846
// module chunks = 0